var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox-wrapper"},[_c('span',{staticClass:"checkbox",class:{ on: _vm.checked },on:{"click":_vm.clickHandler}})])}
var staticRenderFns = []

export { render, staticRenderFns }